(()=>{const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches,root=()=>window.Shopify?.routes?.root||'/';

function setButtonState(button,label,state=''){
  if(!button)return;
  button.classList.toggle('is-added',state==='added');
  button.textContent=label;
}

async function addItems(button,ids){
  const clean=[...new Set((ids||[]).map(id=>Number(id)).filter(Boolean))];
  if(!clean.length||button.disabled)return;
  if(!button._bnOriginalHTML)button._bnOriginalHTML=button.innerHTML;
  button.disabled=true;
  setButtonState(button,'DODAJĘ');
  try{
    const response=await fetch(root()+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:clean.map(id=>({id,quantity:1}))})
    });
    if(!response.ok)throw new Error('cart');
    setButtonState(button,button.dataset.successLabel||'DODANO DO KOSZYKA','added');
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
    setTimeout(()=>{button.disabled=false;button.classList.remove('is-added');button.innerHTML=button._bnOriginalHTML},1500);
  }catch(error){
    setButtonState(button,'SPRAWDŹ DOSTĘPNOŚĆ');
    setTimeout(()=>{button.disabled=false;button.classList.remove('is-added');button.innerHTML=button._bnOriginalHTML},1700);
  }
}

function updateStage(stage,source){
  if(!stage||!source)return;
  const video=stage.querySelector('video'),image=stage.querySelector('img'),title=stage.querySelector('[data-start-stage-title]'),copy=stage.querySelector('[data-start-stage-copy]'),label=stage.querySelector('[data-start-stage-label]'),videoUrl=source.dataset.video||'',imageUrl=source.dataset.image||'';
  if(video){
    if(videoUrl){
      if(video.getAttribute('src')!==videoUrl){video.pause();video.src=videoUrl;video.poster=imageUrl;video.load();video.play().catch(()=>{})}
      video.hidden=false;
    }else{video.pause();video.removeAttribute('src');video.hidden=true}
  }
  if(image){image.src=imageUrl;image.hidden=!!videoUrl||!imageUrl}
  if(title)title.textContent=source.dataset.title||'';
  if(copy)copy.textContent=source.dataset.copy||'';
  if(label)label.textContent=source.dataset.label||'';
}

function boot(scope=document){
  scope.querySelectorAll?.('.bn-start-reveal').forEach(node=>{
    if(node.dataset.startReveal)return;
    node.dataset.startReveal='1';
    if(reduced||!('IntersectionObserver'in window)){node.classList.add('is-visible');return}
    const observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){node.classList.add('is-visible');observer.disconnect()}},{threshold:.13});
    observer.observe(node);
  });

  scope.querySelectorAll?.('[data-start-tilt]').forEach(card=>{
    if(card.dataset.startReady)return;
    card.dataset.startReady='1';
    card.addEventListener('pointermove',event=>{
      if(reduced||event.pointerType==='touch')return;
      const rect=card.getBoundingClientRect(),x=(event.clientX-rect.left)/rect.width,y=(event.clientY-rect.top)/rect.height;
      card.style.setProperty('--x',x*100+'%');card.style.setProperty('--y',y*100+'%');
      card.style.transform=`perspective(900px) rotateX(${(0.5-y)*4.5}deg) rotateY(${(x-0.5)*5.5}deg)`;
    });
    card.addEventListener('pointerleave',()=>card.style.removeProperty('transform'));
  });

  scope.querySelectorAll?.('[data-start-scroll]').forEach(trigger=>{
    if(trigger.dataset.startReady)return;
    trigger.dataset.startReady='1';
    trigger.addEventListener('click',event=>{
      const selector=trigger.dataset.startScroll;if(!selector)return;
      event.preventDefault();document.querySelector(selector)?.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
    });
  });

  scope.querySelectorAll?.('[data-start-process]').forEach(process=>{
    if(process.dataset.startReady)return;
    process.dataset.startReady='1';
    const stage=process.querySelector('[data-start-stage]'),steps=[...process.querySelectorAll('[data-start-step]')];
    const activate=step=>{steps.forEach(item=>item.classList.toggle('is-active',item===step));updateStage(stage,step)};
    steps.forEach(step=>{
      step.addEventListener('mouseenter',()=>activate(step));
      step.addEventListener('focusin',()=>activate(step));
      step.addEventListener('click',event=>{if(!event.target.closest('a,button'))activate(step)});
      step.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();activate(step)}});
    });
    if('IntersectionObserver'in window&&!reduced&&window.matchMedia('(min-width: 990px)').matches){
      const observer=new IntersectionObserver(entries=>{
        const visible=entries.filter(entry=>entry.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];
        if(visible)activate(visible.target);
      },{rootMargin:'-22% 0px -52% 0px',threshold:[.08,.22,.45]});
      steps.forEach(step=>observer.observe(step));
    }
    if(steps[0])activate(steps[0]);
  });

  scope.querySelectorAll?.('[data-start-accordion]').forEach(accordion=>{
    if(accordion.dataset.startReady)return;
    accordion.dataset.startReady='1';
    accordion.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-start-accordion-trigger]');if(!trigger)return;
      const item=trigger.closest('.bn-start-accordion__item'),open=item.classList.contains('is-open');
      accordion.querySelectorAll('.bn-start-accordion__item').forEach(row=>{row.classList.remove('is-open');row.querySelector('button')?.setAttribute('aria-expanded','false')});
      if(!open){item.classList.add('is-open');trigger.setAttribute('aria-expanded','true')}
    });
  });

  scope.querySelectorAll?.('[data-bn-start-atc]').forEach(button=>{
    if(button.dataset.startReady)return;
    button.dataset.startReady='1';
    button.addEventListener('click',event=>{event.preventDefault();addItems(button,[button.dataset.variantId])});
  });

  scope.querySelectorAll?.('[data-bn-start-atc-all]').forEach(button=>{
    if(button.dataset.startReady)return;
    button.dataset.startReady='1';
    button.addEventListener('click',event=>{
      event.preventDefault();
      addItems(button,(button.dataset.variantIds||'').split(','));
    });
  });
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document),{once:true});else boot(document);
document.addEventListener('shopify:section:load',event=>boot(event.target));
})();